import { extractStringValueSet } from './extract-properties';

export default class ItemStatus {

    static readonly Canceled: string = 'canceled';
    static readonly Complete: string = 'complete';
    static readonly ConsumeAtYourOwnRisk = 'consume-at-your-own-risk';
    static readonly Delayed: string = 'delayed';
    static readonly FailedAndRestarted = 'failed-and-restarted';
    static readonly InProgress: string = 'in-progress';
    static readonly QCFail: string = 'qc-fail';
    static readonly ToDo: string = null;

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
            this._valueSet.add(this.ToDo);
        }

        return new Set(this._valueSet);
    }
}
